import { Box, Stack } from "@mui/material";
import type { FC } from "react";
import { PackageNode } from "./PackageNode";
import type { PackageFamily } from "./PackagesList";

interface Props {
  readonly packages: PackageFamily[];
  readonly onClick: (id: string) => void;
  readonly onContextMenu: (id: string) => void;
  readonly onMovePackage: (id: string, direction: "up" | "down") => void;
}

export const PackageChildren: FC<Props> = ({ packages, onContextMenu, onClick, onMovePackage }) => {
  if (packages.length === 0) {
    return null;
  }

  return (
    <Stack
      spacing={1}
      sx={{
        mt: 2,
        pl: 3,
        ml: 3,
        borderLeft: (theme) => `2px solid ${theme.palette.divider}`,
      }}
    >
      {packages.map((child, idx) => (
        <Box
          key={child.root.id.id}
          sx={{
            position: "relative",
            "&::before": {
              content: '""',
              position: "absolute",
              left: -16,
              top: 32,
              width: 16,
              borderTop: (theme) => `2px solid ${theme.palette.divider}`,
            },
          }}
        >
          <PackageNode
            family={child}
            isFirst={idx === 0}
            isLast={idx === packages.length - 1}
            onClick={onClick}
            onContextMenu={onContextMenu}
            onMovePackage={onMovePackage}
          />
        </Box>
      ))}
    </Stack>
  );
};
